module.exports = __webpack_public_path__ + "static/img/4.c2ab0340.png";